/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_PortraitInputs */

const en_val_portrait = /** @type {(inputs: Val_PortraitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portrait`)
};

const es_val_portrait = /** @type {(inputs: Val_PortraitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrato`)
};

const fr_val_portrait = /** @type {(inputs: Val_PortraitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portrait`)
};

const de_val_portrait = /** @type {(inputs: Val_PortraitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porträt`)
};

const ja_val_portrait = /** @type {(inputs: Val_PortraitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポートレート`)
};

const zh_val_portrait = /** @type {(inputs: Val_PortraitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人像摄影`)
};

const ar_val_portrait = /** @type {(inputs: Val_PortraitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصوير شخصي (بورتريه)`)
};

const id_val_portrait = /** @type {(inputs: Val_PortraitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potret`)
};

const it_val_portrait = /** @type {(inputs: Val_PortraitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritratto`)
};

const ru_val_portrait = /** @type {(inputs: Val_PortraitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Портрет`)
};

const pt_val_portrait = /** @type {(inputs: Val_PortraitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrato`)
};

const ko_val_portrait = /** @type {(inputs: Val_PortraitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인물 사진`)
};

/**
* | output |
* | --- |
* | "Portrait" |
*
* @param {Val_PortraitInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_portrait = /** @type {((inputs?: Val_PortraitInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_PortraitInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_portrait(inputs)
	if (locale === "es") return es_val_portrait(inputs)
	if (locale === "fr") return fr_val_portrait(inputs)
	if (locale === "de") return de_val_portrait(inputs)
	if (locale === "ja") return ja_val_portrait(inputs)
	if (locale === "zh") return zh_val_portrait(inputs)
	if (locale === "ar") return ar_val_portrait(inputs)
	if (locale === "id") return id_val_portrait(inputs)
	if (locale === "it") return it_val_portrait(inputs)
	if (locale === "ru") return ru_val_portrait(inputs)
	if (locale === "pt") return pt_val_portrait(inputs)
	return ko_val_portrait(inputs)
});